/** @jsxImportSource @emotion/react */
import { useEffect, useState, useRef,useContext } from "react";
import PDFViewer from "../../PDFViewer";
import classes from './style';
import { onFileSelection } from '../helper';
import CloseIcon from '@mui/icons-material/Close';
import { getBlob } from "../../../Helper/Functions";
import { StyledTextField } from "../../CustomTextfield";
import FullScreenLoader from '../../../Components/FullScreenLoader';
import Dialog from "../../Upload/Dialog";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DialogTitle, Grid, Tooltip, IconButton, DialogActions, Button, useMediaQuery, DialogContent, useTheme, Typography } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { Il8nContext } from '../../../Helper/i18n';
import axios from '../../../Helper/Axios/interceptor';
import config from '../../../config';

var canvasId = 0;
var screamId = 0;
function UploadPdf(props) {
  const { data, handleClose, open, noButtons, onUpload, setSnackBar, loading, onPdfRemove, documentUploadedDetails, selectedDocumentMasterData,setDocUploadLoading, onSave, setShowFailPopup, setOcrLoader, proofType, getAllAdressData, isAddressDetails, isObjection, stageDetailsResp, uploadScreen } = props;
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('lg'));
  const { isMandatoryDocExpiryDate, isMandatoryDocNumber, documentName, documentTypeName } = selectedDocumentMasterData || {};
  const upload = useRef(null);
  const viewerRef = useRef(null);
  const [pdf, setPdf] = useState(null);
  const [documentNumber, setDocumentNumber] = useState("")
  const [aadharVal, setAadharVal] = useState(false)
  const [valid, setValid] = useState(true);
  const [documentExpiryDate, setDocumentExpiryDate] = useState(new Date().getTime())
  const [aadharImg, setAadharImg] = useState(null)
  const localeText = useContext(Il8nContext)
  const isAadhaar = (documentTypeName==='Correspondence Proof Of Address' || documentTypeName === "Permanent Proof Of Address")

  useEffect(() => {
    if(data && Object.keys(data).length > 0 && data?.proofType === "image"){
        setAadharImg(data)
        viewerRef.current = <img style={{ width: '', height: '100%' }} src={data?.data} />
    }else if (data && Object.keys(data).length > 0) {
      setPdf(data)
      viewerRef.current = <PDFViewer pdfFile={getBlob(data?.data)} />
    }
  }, [data])

  useEffect(() => {
    isMandatoryDocExpiryDate && setDocumentExpiryDate(documentUploadedDetails[0]?.documentExpiryDate || new Date().getTime())
    isMandatoryDocNumber && setDocumentNumber(documentUploadedDetails[0]?.documentNumber || "")
  }, [pdf])

  function handleDocumentNumber(e) {
    if(documentName.includes("Aadhaar")){
      let reg = /^[0-9*_\-\\;':"\\,.\/?]\d{0,3}$/;
      let result = reg.test(e.target.value)
      setValid(result)
      setAadharVal(true)
      setDocumentNumber(e.target.value)
    }
    else{
      let reg = /^[a-zA-Z0-9*_\-\\;':"\\,.\/?]*$/
      let result = reg.test(e.target.value)
      setValid(result)
      setAadharVal(false)
      setDocumentNumber(e.target.value)
    }
  }

  async function handleInputChange() {
    if (upload.current.files[0]) {
      let response = await onFileSelection(upload.current.files[0])
      if (response.data) {
        setPdf(response)
        viewerRef.current = <PDFViewer pdfFile={getBlob(response.data)} />
      } else {
        setSnackBar(response)
      }
    } else {
      setSnackBar({ show: true, message: localeText?.uploadValid, type: 'error' })
    }
  }

  function isInteger(value) {
    let parsedValue = parseInt(value, 10);
    return !isNaN(parsedValue) && parsedValue.toString() === value;
  }

  function handleUpload() {
    if (isMandatoryDocNumber && (documentNumber?.toString().trim() === "")) {
      setSnackBar({ show: true, message: localeText?.uploadNoMandatory, type: 'error' })
    } else if (isMandatoryDocExpiryDate && (documentExpiryDate?.toString().trim() === "")) {
      setSnackBar({ show: true, message: localeText?.uploadDateMandatory, type: 'error' })
    } else if (isMandatoryDocExpiryDate && (documentExpiryDate < new Date().setHours(0, 0, 0, 0))) {
      setSnackBar({ show: true, message: localeText?.uploadExpiry, type: 'error' })
    } else {
      let uploadDocName = documentName.includes("Aadhaar") ? "verifyAadhar" : documentName.includes("PAN Card") ? "verifyPAN" : ""
      let apiCallUrl = config[uploadDocName]
      if (apiCallUrl) {
        const source = axios.CancelToken.source();
        setOcrLoader(true)
        const payload = {
          "mimeType": "application/pdf",
          "file": pdf?.data.split("base64,")[1],
          "isOCR": (isObjection && isAddressDetails) ? false : isAddressDetails ? true : false
        }
        axios.post(`${process.env.REACT_APP_AARAMBHAH_URL}${apiCallUrl}`, payload,
          {
            cancelToken: source.token,
            timeout: 20000, // time in ms
          }
        )
        .then(response => {
          if(((response?.OCR?.status == true) && (response?.OCR?.isForceProceed == false)) || ((response?.OCR?.status == false) && (response?.OCR?.isForceProceed == true))) {
              setOcrLoader(false)
                const Data = {
                  [proofType?.code?.toLowerCase()]: [
                    {
                      documentTypeCode: proofType.id,
                      documentSubType: proofType.type,
                      documentId: selectedDocumentMasterData.id || "",
                      documentScreen: proofType.screen,
                      documentName: selectedDocumentMasterData.documentName || "",
                      documentNumber: document.documentNumber,
                      documentExpiryDate: document.documentExpiryDate,
                      ocrDetails: {
                        address: response.OCR.address,
                        address_pin: response.OCR.pincode
                      }
                    }
                  ]
                };
                if (documentName.includes("Aadhaar")) {
                  if(isInteger(response?.OCR?.pincode)){
                    getAllAdressData({ ...Data });
                  }
                }
                else if(documentName.includes("PAN Card")){
                  onUpload(pdf, documentNumber, documentExpiryDate)
                }
            }
            else if (response?.OCR?.status == false && response?.OCR?.isForceProceed == false) {
              setOcrLoader(false)
              setShowFailPopup({ showPopup:true,showPopupMessage:response?.OCR?.message || localeText.aadhaarStatusFailMessage1})
            }
            if(response?.OCR?.boundingPolly){
              if(isAddressDetails && response?.OCR?.isForceProceed == true || (!isObjection && isAddressDetails && !(isInteger(response?.OCR?.pincode)))){
                createCanvas(response.OCR,true)
              }else{
                createCanvas(response.OCR)
              }
              handleClose(pdf)
              setOcrLoader(false)
            }
        })
          .catch(error => {
            console.log(error)
            if(error.message){
              onUpload(pdf, documentNumber, documentExpiryDate ,true)
              setOcrLoader(false)
            }
             handleClose(pdf)
             setOcrLoader(false)
              if (axios.isCancel(error)) {
                console.log('Request canceled:', error.message);
              } else if (error.code === 'ECONNABORTED') {
                console.log('Request timed out');
              } else {
                console.log('Request Error:', error.message);
              }
          })
      } else {
         onUpload(pdf, documentNumber, documentExpiryDate)
      }
    }
  }

  function handleRemove() {
    setPdf(null);
    setAadharImg(null)
    viewerRef.current = null;
    onPdfRemove()
    handleClose(pdf)
  }

  function createCanvas(resp,isForceProceedStatus)  {
    if(resp?.imageData !== null && resp.hasOwnProperty('imageData')) {
      var canvas = document.createElement("canvas")
      canvas.id = "canvas" + (canvasId++)
      canvas.style.display = "none"
      document.body.appendChild(canvas)
      var img = document.createElement("img")
      img.id = "scream" + (screamId++)
      img.style.display = "none"
      img.src = "data:image/jpeg;base64,"+ resp?.imageData
      document.body.appendChild(img)
      var aadhaarImage = document.getElementById("scream" + (screamId - 1));
      aadhaarImage.onload = function(){
        evtPhoto(resp,isForceProceedStatus)
      }
    }
  }

  const evtPhoto = (resp,isForceProceedStatus) => {
    var r = typeof resp?.boundingPolly == "string" ? JSON.parse(resp?.boundingPolly) : resp?.boundingPolly
    if (!r.responses) {
      return;
    }
    var des = r.responses[0].textAnnotations[0].description.split("\n")
    var regex = /(?:XXXX\sXXXX\s\d{4}|\d{4}\s\d{4}\s\d{4})/gm;
    var filtered = des.find(txt => regex.test(txt));
    if (!filtered)
      return
    
    var ann1 = r.responses[0].textAnnotations.filter(ann => ann.description == filtered.split(" ")[0])
    var ann2 = r.responses[0].textAnnotations.filter(ann => ann.description == filtered.split(" ")[1])
    var c = document.getElementById("canvas" + (canvasId - 1));
    var ctx = c.getContext("2d");
    
    var img = document.getElementById("scream" + (screamId - 1));
    var realWidth = img.naturalWidth;
    var realHeight = img.naturalHeight;
    ctx.canvas.width = realWidth
    ctx.canvas.height = realHeight
    ctx.drawImage(img, 0, 0);
    ctx.fillStyle = '#ffffff';
    ann1.forEach(ann => {
      ctx.beginPath();
      ctx.moveTo(ann.boundingPoly.vertices[0].x, ann.boundingPoly.vertices[0].y);
      ctx.lineTo(ann.boundingPoly.vertices[1].x, ann.boundingPoly.vertices[1].y);
      ctx.lineTo(ann.boundingPoly.vertices[2].x, ann.boundingPoly.vertices[2].y);
      ctx.lineTo(ann.boundingPoly.vertices[3].x, ann.boundingPoly.vertices[3].y);
      ctx.closePath();
      ctx.fill();
    })
    ann2.forEach(ann => {
      ctx.beginPath();
      ctx.moveTo(ann.boundingPoly.vertices[0].x, ann.boundingPoly.vertices[0].y);
      ctx.lineTo(ann.boundingPoly.vertices[1].x, ann.boundingPoly.vertices[1].y);
      ctx.lineTo(ann.boundingPoly.vertices[2].x, ann.boundingPoly.vertices[2].y);
      ctx.lineTo(ann.boundingPoly.vertices[3].x, ann.boundingPoly.vertices[3].y);
      ctx.closePath();
      ctx.fill();
    })
    c.toBlob(blob => {
      var fr = new FileReader()
      fr.onloadend = () => {
        onSave([fr.result], 0, documentNumber || "", documentExpiryDate || "", false, isForceProceedStatus)
        document.body.removeChild(c)
        c.remove();
        img.remove()
        c.id = "nil"
      }
      fr.readAsDataURL(blob)
    })
  }

  const title = () => {
    return (
      <Grid container style={classes.centerContent}>
        <div item sm={10} xs={10} style={classes.title}>
          {data?.name || localeText?.uploadUploadPdf}
        </div>
        <div item sm={2} xs={2} style={{ textAlign: "right" }}>
          <Tooltip title="Close" aria-label="close">
            <IconButton aria-label="close" style={classes.closeButton} onClick={() => handleClose(pdf)} size="large">
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </div>
      </Grid>
    )
  }

  const content = () => {
    return (
      <Grid container style={{ height: "80%" }}>
        {!aadharImg ? <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <PictureAsPdfIcon  color="primary" css={{width:"75px", height:"75px"}}  onClick={()=>window.open(getBlob(data?.data))} />
        </Grid> :
         <Grid item xs={6} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <img style={{ width: '', height: '100%' }} src={aadharImg} />
        </Grid>}
      </Grid>
    )
  }

  const actions = () => {
    return (
      <Grid container spacing={2} style={{marginBottom:60 }}>
        <Grid item xs={12} md={3} style={{ paddingLeft: 24,marginTop:5 }}>
          {
            isMandatoryDocExpiryDate &&
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                css={{ marginTop: "10px" }}
                inputFormat="DD/MM/YYYY"
                id="dateOfBirth"
                name="dateOfBirth"
                minDate={new Date()}
                value={new Date(Number(documentExpiryDate)) || ""}
                label={localeText?.uploadDocument}
                disabled={documentUploadedDetails[0]}
                onChange={(e) => setDocumentExpiryDate(new Date(e.$d).getTime())}
                renderInput={(params) => <StyledTextField fullWidth {...params} />}
              />
            </LocalizationProvider>
          }
          {
            isMandatoryDocNumber &&
            <StyledTextField
              style={{ marginTop: "20px" }}
              InputLabelProps={{ shrink: true }}
              label={localeText?.uploadDocumentNumber}
              variant="outlined"
              fullWidth
              value={documentNumber || documentUploadedDetails[0]?.documentNumber}
              disabled={documentUploadedDetails[0]}
              onChange={(e) => handleDocumentNumber(e)}
              helperText={(!valid && aadharVal) ? "Please enter valid last 4 digit of aadhaar" : !valid ? "Please enter valid document number" : ""}
              inputProps={{ maxLength: aadharVal && 4 }}
            />
          }
        </Grid>
        <Grid item md={12} xs={12} className={`${classes.center} ${classes.actions}`} style={pdf == null ? { justifyContent: 'space-between' } : { justifyContent: 'flex-end' }}>
          {
            pdf == null ?
              <div style={{ margin: "auto", width: '70px', height: '70px' }} onClick={() => upload.current.click()}>
                <input ref={upload} id={'uploadPdf'} type='file' accept={".pdf"} style={{ display: 'none' }} onChange={handleInputChange} />
                <img style={{ cursor: "pointer" }} src={"images/add_icon.svg"} width={"70px"} height={"70px"} alt="" />
              </div>
              :
              null
          }
          {
            !noButtons ?
              <div style={{ display: 'flex', alignItems: 'center', textAlign: 'right' }}>
                {<Button variant="contained" style={{ width: '134px', marginRight: '5px' }} onClick={handleRemove} disabled={pdf == null || 
                  (
                    (documentTypeName === "Proof Of Identity") && stageDetailsResp?.isDigiPanUploaded && stageDetailsResp?.accountOpeningType?.toLocaleLowerCase() === "digi") || ((documentTypeName === "Correspondence Proof Of Address"|| documentTypeName === "Permanent Proof Of Address") && uploadScreen)
                  }>
                    {localeText?.uploadRemove}
                  </Button>}

                <Button color="primary" variant="contained" style={{ width: '134px' }} onClick={handleUpload} disabled={pdf == null || documentUploadedDetails[0] || aadharVal ? documentNumber?.length !== 4 : false}>
                  {localeText?.uploadUpload}
                </Button>
              </div>
              : 
              <></>
          }
        </Grid>
      </Grid>
    )
  }

  return (
    <>
      <Dialog open={open} handleClose={handleClose} fullWidth={false} maxWidth='md'>
        <DialogTitle className={classes.titleDiv}>
          {title()}
        </DialogTitle>
        <DialogContent className={classes.content} style={{ height: matches ? "50%" : "100%", overflowY: "hidden" }}>
          {content()}
        </DialogContent>
        <DialogActions style={{ height: '150px', padding: '8px 50px' }}>
          {actions()}
        </DialogActions>
      </Dialog>
      {loading && <FullScreenLoader />}
    </>
  )
}

export default UploadPdf;